$(function () {
  window.allowSubmit = false;
  $("[id^=child-destroy-modal]").each(function(index, item) {

    const modalId = $(item).attr('id');
    const id = modalId.split('-')[3];
    var sSmodal = $(`#${modalId}`).modal({ backdrop: 'static', keyboard: false, show: true });

    $('#child-destroy-submit-button-' + id).on('click', function (event) {
      event.preventDefault();
      $(`#child-destroy-modal-${id} .step1`).removeAttr('hidden')
      sSmodal.modal('show');
    });

    $(`#child-destroy-step1-cancel-${id}`).on('click', function () {
      sSmodal.modal('hide');
    });

    $(`#modal-child-destroy-submit-button-${id}`).on('click', function (event) {
      if (!window.allowSubmit) {
        event.preventDefault();
        const childEmail = $(`#child-email-modal-${id}`).val().trim();
        const expectedChildEmail = $(`#expected-child-email-modal-${id}`).val().trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const validEmail = emailRegex.test(childEmail);
        if (!validEmail) {
          alert(I18nMessages.invalidEmail);
          return;
        }

        if (childEmail !== expectedChildEmail) {
          alert(I18nMessages.emailMismatch);
          return;
        }
        window.allowSubmit = true;

        this.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }));
      }
    });

    const updateChildDestroySubmitButtonState = function () {
      if ($(`#child-email-modal-${id}`).val().trim().length != 0) {
        $(`#modal-child-destroy-submit-button-${id}`).removeClass('disabled');
      } else {
        $(`#modal-child-destroy-submit-button-${id}`).addClass('disabled');
      }
    };

    $(`#child-email-modal-${id}`).on('input change keyup', updateChildDestroySubmitButtonState);
    updateChildDestroySubmitButtonState();
  });
});
